import { FormattedDescription } from '@/components/Countdown/FormattedDescription';
import { renderer } from '@/components/Countdown/renderer';
import { Container, Text, Wrapper } from '@/components/Countdown/styled';
import { useMounted } from '@/hooks/useMounted';
import Countdown from 'react-countdown';

export type CountDownSettings = {
  id: number;
  status?: 'published' | 'draft' | 'deleted';
  owner?: number;
  created_on?: string | Date | null;
  description?: string | null;
  start_date?: string | Date | null;
  end_date?: string | Date | null;
  timezone?: string | null;
};

type CountDownProps = {
  settings: CountDownSettings;
};

export function CountDownTimer({ settings }: CountDownProps) {
  const { start_date, end_date, description, status, timezone } = settings;
  const tz: string = timezone && timezone !== '' ? timezone : 'UTC';

  const isMounted = useMounted();

  const currentDate = new Date();
  const startDate = start_date ? new Date(start_date) : null;
  const endDate = end_date ? new Date(end_date) : null;

  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
  });

  if (!isMounted || status !== 'published') {
    return null;
  }
  if (!startDate || !endDate) {
    return null;
  }

  const endDateInTimezone = new Date(formatter.format(endDate));

  if (currentDate < startDate || currentDate > endDate) {
    return null;
  }

  return (
    <Container>
      <Wrapper>
        <Countdown date={endDateInTimezone} renderer={renderer} />
        <Text>
          <FormattedDescription description={description ?? ''} />
        </Text>
      </Wrapper>
    </Container>
  );
}
